/** Forum skoru: konu×5 + ileti×2 + üye×10, kuruluş yılına bölünür. */
export function calculateForumScore(
  topics: number,
  posts: number,
  members: number,
  foundedYear: number
): number {
  if (!foundedYear || foundedYear <= 0) return 0;
  const topicsScore = (topics || 0) * 5;
  const postsScore = (posts || 0) * 2;
  const membersScore = (members || 0) * 10;
  return Math.round((topicsScore + postsScore + membersScore) / foundedYear);
}

export function getForumScoreBreakdown(
  topics: number,
  posts: number,
  members: number,
  foundedYear: number
) {
  const t = topics || 0;
  const p = posts || 0;
  const m = members || 0;
  const year = foundedYear > 0 ? foundedYear : 0;
  const raw = t * 5 + p * 2 + m * 10;
  const score = year > 0 ? Math.round(raw / year) : 0;
  return { score, raw, year, topics: t, posts: p, members: m };
}
